import { useMarkdownStyle } from "../../components/markdown/MarkdownStyleContext";
import { sameNodePosition, } from "../../components/markdown/utils";
import React, { memo } from "react";
export const StrongBlock = memo(function StrongBlock({ children }) {
    const { textColor } = useMarkdownStyle();
    return React.createElement("strong", { className: `font-semibold ${textColor}` }, children);
}, (prev, next) => sameNodePosition(prev.node, next.node));
//# sourceMappingURL=StrongBlock.js.map